module.exports = __webpack_public_path__ + "media/reveal.cb5e50bf.mp3";